export default "__VITE_ASSET__DKNlksAi__"